var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKeyboard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 5.25C2.09315 5.25 0.75 6.59315 0.75 8.25V15.75C0.75 17.4069 2.09315 18.75 3.75 18.75H20.25C21.9069 18.75 23.25 17.4069 23.25 15.75V8.25C23.25 6.59315 21.9069 5.25 20.25 5.25H3.75ZM3.75 6.75C2.92157 6.75 2.25 7.42157 2.25 8.25V15.75C2.25 16.5784 2.92157 17.25 3.75 17.25H20.25C21.0784 17.25 21.75 16.5784 21.75 15.75V8.25C21.75 7.42157 21.0784 6.75 20.25 6.75H3.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8.25H5.25V9.75H3.75V8.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 11.25H5.25V12.75H3.75V11.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 14.25H5.25V15.75H3.75V14.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 8.25H8.25V9.75H6.75V8.25Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.25H8.25V12.75H6.75V11.25Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 14.25H17.25V15.75H6.75V14.25Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 8.25H11.25V9.75H9.75V8.25Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11.25H11.25V12.75H9.75V11.25Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 8.25H14.25V9.75H12.75V8.25Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 11.25H14.25V12.75H12.75V11.25Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.25H17.25V9.75H15.75V8.25Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 11.25H17.25V12.75H15.75V11.25Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 8.25H20.25V9.75H18.75V8.25Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 11.25H20.25V12.75H18.75V11.25Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 14.25H20.25V15.75H18.75V14.25Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKeyboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/keyboard.6587ac234c08003b79bc64d753dec1b9.svg";